module.exports = __webpack_public_path__ + "static/media/terpeca-logo.c7b7b835.avif";


//////////////////
// WEBPACK FOOTER
// ./src/images/Awards/terpeca-logo.avif
// module id = 616
// module chunks = 0 1 2 3 4 34